import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Dropdown, List, Menu, Spin, Switch } from "antd";
import { Link, useRouteMatch } from "react-router-dom";

import ListItem from "./components/list-item";
import Draft from "./components/draft";

import "./votings-list.scss";
import { getAllVoting } from "../../store/thunks/get-voting";
import { ChevronDownIcon } from "../../../../resource/icons";
import useSetRefreshFn from "../../../../hooks/useSetRefreshFn";
import { getOneVoting } from "../../store/thunks/get-one-voting";

const sortText = {
	active: "Сначала активные",
	old: "Сначала старые",
	recently: "Сначала недавние",
};

const VotingsList = ({ height }) => {
	const dispatch = useDispatch();
	const [isDraftShown, showDraft] = useState();
	const [onlyActive, setOnlyActive] = useState();
	const [sort, setSort] = useState("recently");
	const [dropdownOpened, setDropdownOpened] = useState();

	const votingsList = useSelector((state) => state.votingStore.votingsList);
	const listLoading = useSelector((state) => state.votingStore.listLoading);
	const isNewPage = !!useRouteMatch("/Voting/new");
	const votingItemMatch = useRouteMatch("/Voting/:id");
	
	useEffect(() => {
		showDraft(isNewPage || sessionStorage.getItem("new-voting"));
	}, [isNewPage]);

	useEffect(() => {
		dispatch(getAllVoting(onlyActive, sort));
	}, [onlyActive, sort]);

	useSetRefreshFn(() => {
		dispatch(getAllVoting(onlyActive, sort));

		if (votingItemMatch?.params?.id) {
			dispatch(getOneVoting(votingItemMatch.params.id))
		}
	}, [onlyActive, sort, votingItemMatch?.params?.id])

	const menu = (
		<Menu>
			<Menu.Item key={`active`} onClick={() => setSort("active")}>
				<span>{sortText.active}</span>
			</Menu.Item>
			<Menu.Item key={`recently`} onClick={() => setSort("recently")}>
				<span>{sortText.recently}</span>
			</Menu.Item>
			<Menu.Item key={`old`} onClick={() => setSort("old")}>
				<span>{sortText.old}</span>
			</Menu.Item>
		</Menu>
	);
	return (
		<div style={{ height }} className="votings-list-container">
			<div className="votings-list-settings">
				<div
					className="active_filtration"
					onClick={() => setOnlyActive(!onlyActive)}
				>
					<Switch size="small" checked={onlyActive} className="active_switch" />
					<span>Только активные</span>
				</div>
				<Dropdown
					onVisibleChange={setDropdownOpened}
					defaultValue="later"
					overlay={menu}
					trigger={["click"]}
					placement="bottomRight"
				>
					<span className="sort">
						<span>{sortText[sort]}</span>
						<ChevronDownIcon
							className={dropdownOpened ? `chevron-opened` : ""}
						/>
					</span>
				</Dropdown>
			</div>
			<Spin
				style={{ minHeight: 300 }}
				size="large"
				spinning={listLoading}
				tip="Загрузка..."
				delay={100}
			>
				{isDraftShown && <Draft isNewPage={isNewPage} />}

				{votingsList && votingsList.length > 0 && (
					<div className="votings-list">
						<List
							itemLayout="vertical"
							dataSource={votingsList}
							renderItem={(item) => {
								return (
									<>
										<Link
											to={`/Voting/${item.id}`}
											className="list-item-container"
										>
											<ListItem item={item} />
										</Link>
									</>
								);
							}}
						/>
					</div>
				)}

				{votingsList && votingsList.length == 0 && !isDraftShown && (
					<Alert
						style={{ marginTop: 20 }}
						message="Опросы не найдены"
						type="info"
						showIcon
					/>
				)}
			</Spin>
		</div>
	);
};

export default VotingsList;
